'use client';

import React from 'react';
import { useRouter, usePathname, useSearchParams } from 'next/navigation';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~/components/ui/select';

const orderList = {
  new_arrival: '新着順',
  deadline: '掲載終了が近い順',
  salary: '年収が高い順',
};

type OrderType = keyof typeof orderList | '';

const initialOrder = (searchParams: URLSearchParams) => {
  const orderName = searchParams.get('jobs_search[order_name]');
  if (orderName && orderName in orderList) {
    return orderName as OrderType;
  }
  return '';
};

export function JobOrderDropdown() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const [order, setOrder] = React.useState<OrderType>(
    initialOrder(searchParams),
  );

  const handleChange = (value: OrderType) => {
    setOrder(value);
    router.push(`${pathname}?jobs_search[order_name]=${value}`);
  };

  return (
    <Select onValueChange={handleChange} defaultValue={order}>
      <SelectTrigger className="w-40">
        <SelectValue placeholder="並び替え" />
      </SelectTrigger>
      <SelectContent className="w-56">
        <SelectGroup>
          {Object.entries(orderList).map(([key, value]) => (
            <SelectItem key={key} value={key}>
              {value}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
